<script>
  export let progress = 0;
</script>

<style>
  .tc-progress-block {
    width: 100%;
    position: relative;
    height: 4px;
    background-color: #cacaca;
    border-radius: 25px;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
  }

  .tc-progress-block--loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 100%;
    background-color: #08c;
    transition: width 0.5s;
  }
</style>

<div class="tc-progress-block">
  <div class="tc-progress-block--loading" style="width:{progress}%;" />
</div>
